'use client';

import { useEffect } from 'react';
import { RecentlyViewedBase } from '@/components/RecentlyViewed/recentlyViewedTypes';
import { getLocalStorageItem, setLocalStorageItem } from '@/utility/localStorage';

const RECENTLY_VIEWED_LIMIT = 20;
export const TRACK_RECENTLY_KEY = 'TRACK_RECENTLY_VIEWED';
export const RECENTLY_ITEM_KEY = 'RECENTLY_VIEWED';

type RecentlyViewedTrackerProps<T extends RecentlyViewedBase> = {
  item: T;
};

const RecentlyViewedTracker = <T extends RecentlyViewedBase>({
  item,
}: RecentlyViewedTrackerProps<T>): null => {
  const storageKey = `${RECENTLY_ITEM_KEY}-${item.type}`;

  useEffect(() => {
    const trackRecentlyViewed = getLocalStorageItem<boolean>(TRACK_RECENTLY_KEY) ?? true;
    if (!trackRecentlyViewed) {
      return;
    }

    const recentlyViewedItems = getLocalStorageItem<T[]>(storageKey) ?? [];

    // Avoid having the same item multiple times in the list
    const remainingStoredItems = recentlyViewedItems.filter(
      (recentItem) => recentItem.id !== item.id
    );

    const newItems = [item, ...remainingStoredItems].slice(0, RECENTLY_VIEWED_LIMIT);

    setLocalStorageItem(storageKey, newItems);
  }, [item, storageKey]);

  return null;
};

export default RecentlyViewedTracker;
